<template>
  <div v-if="list_activites && list_activites.length > 0">
    <div class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 py-2 radius-bottom mt-5">
      <v-icon icon="mdi-hiking" color="darkblue" size="32"></v-icon>
      <div class="text-h5 font-weight-bold">Les activités</div>
    </div>
    <v-row>
      <v-col>
        <div v-for="group in list_activites_grouped" :key="group.name">
          <div v-if="group.name == 'Sans groupe'">
            <div v-for="activite in group.list" :key="activite.id">
              <ActiviteItem :activite="activite" :key="activite.id" :all_activites="list_activites"></ActiviteItem>
            </div>
          </div>
          <div v-else>
            <div class="text-h6 font-weight-bold mt-6">{{ group.name }}</div>
            <DescriptionGroupeActivitesVOLVIC50 v-if="mainStore.module.base == 'VOLVIC50'" :groupe="group.name">
            </DescriptionGroupeActivitesVOLVIC50>

            <ActiviteItem v-for="activite in group.list" :activite="activite" :key="activite.id"
              :all_activites="list_activites"></ActiviteItem>

          </div>
        </div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ActiviteItem from "@/components/Home/Activites/Activite_Item.vue";
import DescriptionGroupeActivitesVOLVIC50 from "@/components/App/Hooks/VOLVIC50/DescriptionGroupeActivites.vue";

export default {

  components: { ActiviteItem, DescriptionGroupeActivitesVOLVIC50 },
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useMainStore),
    all_activites() {
      return this.mainStore.module.activites.list;
    },
    list_activites() {
      return this.mainStore.module.activites.visibles_accueil;
    },
    list_activites_grouped() {
      return this.mainStore.module.activites.visibles_accueil_grouped;
    }
  },

};
</script>

<style lang="scss" scoped></style>